import { isTypeNavigationContainer, TypeNavigationContainerSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulNavigationContainer = ({
  entry,
}: {
  entry: Entry<TypeNavigationContainerSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeNavigationContainer(entry)) {
    return null;
  }

  return <div>ContentfulNavigationContainer</div>;
};

export default ContentfulNavigationContainer;
